import { resolveImageSrc } from "../../api/axios";

export default function PR01({ module }) {
    const item = module.items[0] || {};

    return (
        <div className="w-full">
            {/* Bloc de présentation */}
            <div className="max-w-6xl mx-auto my-4 p-4 bg-white rounded-lg shadow-2xl overflow-hidden flex flex-col md:flex-row">

                {/* Image 1/3 */}
                <div className="md:w-1/3 w-full h-64 md:h-auto">
                    <img
                        src={resolveImageSrc(item.picture1)}
                        alt={item.alt_picture1 || ""}
                        className="rounded-lg w-full h-full object-cover"
                    />
                </div>

                {/* Contenu texte 2/3 */}
                <div className="md:w-2/3 w-full px-6 py-2 flex flex-col justify-center">
                    {item.title && (
                        <h2 className="text-3xl font-bold mb-2">{item.title}</h2>
                    )}
                    {item.description && (
                        <div
                            className="text-gray-800 leading-relaxed text-base"
                            dangerouslySetInnerHTML={{ __html: item.description || "" }}
                        />
                    )}
                </div>

            </div>
        </div>
    );
}
